"use client";

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Smartphone, RefreshCw, ShoppingBag, Search, Server } from 'lucide-react';

export const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: <ShoppingBag className="w-12 h-12 text-blue-300" />,
      title: t('services.webDev'),
      description: t('services.webDevDesc'),
      link: '#contact'
    },
    {
      icon: <Smartphone className="w-12 h-12 text-blue-300" />,
      title: t('services.webMobile'),
      description: t('services.webMobileDesc'),
      link: '#contact'
    },
    {
      icon: <Globe className="w-12 h-12 text-blue-300" />,
      title: t('services.ecommerce'),
      description: t('services.ecommerceDesc'),
      link: '#contact'
    },
    {
      icon: <Search className="w-12 h-12 text-blue-300" />,
      title: t('services.seo'),
      description: t('services.seoDesc'),
      link: '#contact'
    },
    {
      icon: <RefreshCw className="w-12 h-12 text-blue-300" />,
      title: t('services.maintenance'),
      description: t('services.maintenanceDesc'),
      link: '#contact'
    },
    {
      icon: <Server className="w-12 h-12 text-blue-300" />,
      title: t('services.hosting'),
      description: t('services.hostingDesc'),
      externalLink: 'https://docs.netlify.com/platform/overview/'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-blue-600/20 to-slate-900/20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-gradient text-glow">{t('services.title')}</h2>
        <p className="text-blue-200/80 text-center mb-12 max-w-2xl mx-auto">
          {t('services.subtitle')}
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-xl"
            >
              <div className="mb-6">{service.icon}</div>
              <h3 className="text-xl font-bold mb-4 text-white">{service.title}</h3>
              <p className="text-blue-100/80 mb-6">{service.description}</p>
              {service.link && (
                <a
                  href={service.link}
                  className="inline-flex items-center text-blue-300 hover:text-blue-200 transition-colors"
                >
                  <span>{t('services.learnMore')}</span>
                  <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M7 17L17 7M17 7H7M17 7V17" />
                  </svg>
                </a>
              )}
              {service.externalLink && (
                <a
                  href={service.externalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-blue-300 hover:text-blue-200 transition-colors"
                >
                  <span>{t('services.documentation')}</span>
                  <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" />
                  </svg>
                </a>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
